import styled from 'styled-components';

export type ChevronProps = {
  color?: 'black' | 'white' | string;
  direction?: 'left' | 'right' | 'up' | 'down';
  size?: number;
  strokeWidth?: number;
  className?: string;
}

const getRotation = (direction: string) => {
  switch (direction) {
    case 'right': return '45deg';
    case 'down': return '135deg';
    case 'left': return '225deg';
    case 'up': return '315deg';
    default: return '45deg';
  }
};

export const ChevronView = styled.div<ChevronProps>`
  width: ${props => props.size || 10}px;
  height: ${props => props.size || 10}px;
  border-top-width: ${props => props.strokeWidth || 2}px;
  border-right-width: ${props => props.strokeWidth || 2}px;
  border-top-style: solid;
  border-right-style: solid;
  border-color: ${props => props.color || 'black'};
  transform: rotate(${props => getRotation(props.direction || 'right')});
  border-radius: 1px;
`;
